import React from 'react'
import TestDeadlines from '../../../Counseller/Pages/TestDeadlines/testdead-lines'

const EntranceExam = () => {
  return (
        <div className='container' ><TestDeadlines/></div>
  )
}

export default EntranceExam